import { documentationActions } from '../../actions/constant';

const {
  REQUEST_DUE_DOCUMENT_SETTING_REQUEST,
  REQUEST_DUE_DOCUMENT_SETTING_SUCCESS,
  REQUEST_DUE_DOCUMENT_SETTING_FAILURE,
  REQUEST_DUE_DOCUMENT_SETTING_RESET,
  REQUEST_DUE_DOCUMENT_SETTING_LOADING,
} = documentationActions;

const intitialstate: object = {
  response: null,
  dueDocSetting: false,
  loading: false,
};

export const dueDocSettingsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case REQUEST_DUE_DOCUMENT_SETTING_SUCCESS: {
      return {
        ...state,
        dueDocSetting: true,
        response: action.payload,
        loading: false,
      };
    }

    case REQUEST_DUE_DOCUMENT_SETTING_FAILURE:
      return {
        ...state,
        dueDocSetting: false,
        response: action.payload,
        loading: false,
      };

    case REQUEST_DUE_DOCUMENT_SETTING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case REQUEST_DUE_DOCUMENT_SETTING_RESET:
      return intitialstate;

    default:
      return state;
  }
};
